(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('.regal-float-header');
    if (!el) return;
    function update() {
      if (window.scrollY > 40) {
        el.classList.add('regal-is-scrolled');
      } else {
        el.classList.remove('regal-is-scrolled');
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  });

  } catch(e) { console.error(e); }
})();
})();
